import React from "react";

/* Stylized leaf-in-arch logo, matches the reference */
export const Logo = ({ className = "", light = false }) => (
  <a href="#inicio" className={`flex items-center gap-2.5 shrink-0 ${className}`} data-testid="brand-logo">
    <svg width="36" height="46" viewBox="0 0 46 58" fill="none" xmlns="http://www.w3.org/2000/svg" className="shrink-0">
      <path
        d="M2.5 22 C2.5 10, 12 1.5, 23 1.5 C34 1.5, 43.5 10, 43.5 22 L43.5 56.5 L2.5 56.5 Z"
        stroke={light ? "#F5EDE3" : "#2B1F18"}
        strokeWidth="1.4"
        fill="none"
      />
      <path d="M23 16 C23 24, 23 36, 23 44" stroke="#B8694F" strokeWidth="1.2" fill="none" strokeLinecap="round" />
      <path d="M23 22 C19 21, 16 23, 15 26 C18 27, 21 25, 23 22 Z" fill="#B8694F" opacity="0.85" />
      <path d="M23 28 C27 27, 30 29, 31 32 C28 33, 25 31, 23 28 Z" fill="#B8694F" opacity="0.85" />
      <path d="M23 34 C19 33, 16 35, 15 38 C18 39, 21 37, 23 34 Z" fill="#B8694F" opacity="0.85" />
    </svg>
    <span className={`font-serif-display leading-tight text-[15px] ${light ? "text-[var(--cream-50)]" : "text-[var(--ink-900)]"}`}>
      <span className="italic block">Psicóloga</span>
      <span className="block">Andrea Martínez</span>
    </span>
  </a>
);

export default Logo;
